import { SignupForm, Link, useRouter, useStore } from '@/core'
import { CompanyDoesNotExistModal } from '@c/onboarding-app/company-does-not-exist-modal'
import { useTranslation } from 'react-i18next'
import authStyles from '@c/auth-layout/style.module.less'

const TermsAndConditionsLabel = () => {
  const { t } = useTranslation()

  return (
    <>
      {t('auth.signupWithEmailPage.terms.agree_text')}{' '}
      <Link name="termsOfUse" target="_blank">
        {t('auth.signupWithEmailPage.terms.terms_link')}
      </Link>{' '}
      {t('auth.signupWithEmailPage.terms.and')}{' '}
      <Link name="privacyPolicy" target="_blank">
        {t('auth.signupWithEmailPage.terms.privacy_link')}
      </Link>
    </>
  )
}

export const SignupWithEmailPage = () => {
  const { t } = useTranslation()
  const store = useStore()
  const router = useRouter()
  const [, setModal] = store.use(['modal'])

  return (
    <>
      <div className={authStyles.formHeader}>
        <h1>{t('auth.signupWithEmailPage.title')}</h1>
        <p>Complete your signup.</p>
      </div>
      <CompanyDoesNotExistModal />
      <SignupForm
        onError={(err) => {
          if (
            err.fieldErrors?.email?.includes(
              t('auth.signupWithEmailPage.errors.company_not_exist')
            )
          ) {
            setModal('company-does-not-exist')
            return
          }
          throw err
        }}
        onSuccess={(res) => {
          router.push({ name: 'verifyEmail', queries: { userId: res.userId, email: store.get(['forms', 'signup', 'values', 'email']) } })
        }}
        termsLabel={<TermsAndConditionsLabel />}
      />
      <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#6B7B8D' }}>
          {t('auth.signupWithEmailPage.has_account')}{' '}
          <Link name="login" style={{ color: '#2B9FE8', fontWeight: 600 }}>{t('auth.signupWithEmailPage.login_link')}</Link>
        </p>
      </div>
    </>
  )
}
